import { useState } from 'react';
import { entryTabs } from '@/mocks/home';

export default function EntrySection() {
  const [activeId, setActiveId] = useState(entryTabs[0].id);
  const active = entryTabs.find((tab) => tab.id === activeId) ?? entryTabs[0];

  return (
    <section id="entry" className="scroll-mt-24 border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-[0.2em] text-primary-700">Entry Guide</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">三类入口，按顺序依次尝试</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            访问顺序建议为：官网主入口 → 备用线路 → 客户端。下面按类别整理了每一类入口的使用方法与注意事项，
            点击标签即可查看对应说明。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {entryTabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveId(tab.id)}
              className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                activeId === tab.id
                  ? 'bg-foreground-950 font-medium text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              <i className={`${tab.icon} text-base`} aria-hidden="true" />
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-[1.1fr_1fr]">
          <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${active.icon} text-xl`} aria-hidden="true" />
              </span>
              <h3 className="font-heading text-xl font-semibold text-foreground-950">{active.title}</h3>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">{active.desc}</p>
            <ul className="mt-6 space-y-3">
              {active.items.map((item) => (
                <li key={item} className="flex gap-3 text-sm leading-relaxed text-foreground-800">
                  <i className="ri-checkbox-circle-fill mt-0.5 shrink-0 text-base text-accent-500" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <h4 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
                <i className="ri-information-line text-secondary-600" aria-hidden="true" />
                访问顺序建议
              </h4>
              <ol className="mt-4 space-y-3 text-sm text-foreground-700">
                <li className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-semibold text-secondary-900">1</span>
                  优先使用自己收藏的官网入口
                </li>
                <li className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-semibold text-secondary-900">2</span>
                  主入口不可用时切换备用线路
                </li>
                <li className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-semibold text-secondary-900">3</span>
                  网页端不稳定时改用客户端
                </li>
              </ol>
            </div>

            <div className="rounded-lg bg-foreground-950 p-6 text-background-100">
              <h4 className="flex items-center gap-2 font-heading text-base font-semibold text-background-50">
                <i className="ri-error-warning-line text-accent-400" aria-hidden="true" />
                不要这样做
              </h4>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li className="flex gap-2">
                  <i className="ri-close-line mt-0.5 text-accent-400" aria-hidden="true" />
                  通过搜索结果或广告跳转进入
                </li>
                <li className="flex gap-2">
                  <i className="ri-close-line mt-0.5 text-accent-400" aria-hidden="true" />
                  点击陌生私信、群聊里的链接
                </li>
                <li className="flex gap-2">
                  <i className="ri-close-line mt-0.5 text-accent-400" aria-hidden="true" />
                  在非官方页面填写账号或验证码
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}